<template>
  <div>
    <!-- <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin> -->
    <v-main>
      <div>
        <v-row>
          <v-col cols="6" class="text-left">
            <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
          </v-col>
          <v-col cols="6" class="v-margit_button text-right">
            <v-btn
              color="#1B437C"
              depressed
              dark
              @click=";(dialogAdd = true), validate('ADD')"
            >
              <v-icon left>mdi-text-box-plus</v-icon>
              เพิ่ม
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <!-- ADD -->
          <v-dialog v-model="dialogAdd" persistent max-width="60%">
            <v-card>
              <v-form ref="form_add" v-model="validAdd" lazy-validation>
                <v-card-text>
                  <v-container>
                    <v-col class="text-right">
                      <v-btn
                        small
                        color="#E0E0E0"
                        @click=";(dialogAdd = false), clearDataAdd()"
                      >
                        <v-icon color="#173053">mdi-close</v-icon>
                      </v-btn>
                    </v-col>
                    <v-row justify="center">
                      <v-col cols="5" class="text-center">
                        <v-card class="v-card_color">
                          <v-col class="v-card_color text-center">
                            <v-img
                              class="v-margit_img"
                              :src="require('@/assets/Group593.png')"
                            ></v-img>
                          </v-col>
                        </v-card>
                      </v-col>

                      <v-col cols="6" class="v-margit_text_add">
                        <v-col class="text-center">
                          <v-img
                            class="v_text_add"
                            :src="require('@/assets/Grouptitle.png')"
                          ></v-img>
                        </v-col>
                        <v-col cols="12">
                          <v-row style="height: 20px">
                            <v-subheader id="subtext">ชื่อผู้ใช้</v-subheader>
                          </v-row>
                          <v-row style="height: 60px">
                            <v-text-field
                              placeholder="ชื่อผู้ใช้*"
                              v-model="formAdd.userName"
                              :rules="[rules.required]"
                              :counter="15"
                              maxlength="15"
                              dense
                              required
                            ></v-text-field>
                          </v-row>
                        </v-col>
                        <v-col cols="12">
                          <v-row style="height: 20px">
                            <v-subheader id="subtext">รหัสผ่าน</v-subheader>
                          </v-row>
                          <v-row style="height: 60px">
                            <v-text-field
                              placeholder="รหัสผ่าน*"
                              v-model="formAdd.userPassword"
                              :rules="[rules.required]"
                              :counter="15"
                              maxlength="15"
                              dense
                              required
                            ></v-text-field>
                          </v-row>
                        </v-col>
                        <v-col cols="12">
                          <v-row style="height: 20px">
                            <v-subheader id="subtext">E-MAIL</v-subheader>
                          </v-row>
                          <v-row style="height: 60px">
                            <v-text-field
                              v-model="formAdd.userEmail"
                              placeholder="E-mail"
                              dense
                            ></v-text-field>
                          </v-row>
                        </v-col>
                        <!-- :rules="[rules.required, rules.email]" -->
                        <!-- <v-col class="d-flex" cols="12">
                      <v-autocomplete
                        clearable
                        v-model="formAdd.userType"
                        :items="userTypeItem"
                        label="ประเภท Account"
                      ></v-autocomplete>
                    </v-col> -->
                        <v-col cols="12">
                          <v-row style="height: 20px">
                            <v-subheader id="subtext"
                              >กลุ่มผู้ใช้งาน</v-subheader
                            >
                          </v-row>
                          <v-row style="height: 60px">
                            <v-autocomplete
                              clearable
                              v-model="formAdd.userTypeGroup"
                              :items="UserTypeGroup"
                              small-chips
                              :rules="[rules.required]"
                              required
                              placeholder="กลุ่มผู้ใช้งาน"
                            ></v-autocomplete>
                          </v-row>
                        </v-col>
                        <v-col cols="12">
                          <v-row style="height: 20px">
                            <v-subheader id="subtext">สาขา</v-subheader>
                          </v-row>
                          <v-row style="height: 60px">
                            <v-select
                              v-model="formAdd.masBranchID"
                              :items="dataBranch"
                              label="สาขา"
                              dense
                              outlined
                              :rules="[rules.required]"
                            ></v-select>
                          </v-row>
                        </v-col>
                        <v-col cols="12">
                          <v-row style="height: 20px">
                            <v-subheader id="subtext">DISPLAY NAME</v-subheader>
                          </v-row>
                          <v-row style="height: 60px">
                            <v-text-field
                              placeholder="Display Name*"
                              v-model="formAdd.displayName"
                              :rules="[rules.required]"
                              required
                              dense
                            ></v-text-field>
                          </v-row>
                          <!-- <v-autocomplete
                        chips
                        clearable
                        v-model="formAdd.empCode"
                        :items="EmployeeName"
                        label="พนักงาน*"
                        required
                      ></v-autocomplete> -->
                        </v-col>
                        <!-- <v-col>
                      <v-row style="height: 20px">
                      <v-subheader id="subtext">วันที่หมดอายุ</v-subheader>
                      </v-row>
                      <v-row style="height: 60px">
                    <v-menu
                        ref="ExpireMenu"
                        v-model="ExpireMenu"
                        :close-on-content-click="false"
                        :return-value.sync="date"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="formAdd.EXPIRY_DATE"
                            placeholder="วันที่หมดอายุ"
                            prepend-inner-icon="mdi-calendar"
                            readonly
                            dense
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="formAdd.EXPIRY_DATE" no-title scrollable>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="primary"
                            @click="ExpireMenu = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            color="primary"
                            @click="$refs.ExpireMenu.save(formAdd.EXPIRY_DATE)"
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                      </v-row>
                      </v-col> -->
                        <v-col id="margin">
                          <v-row justify="center">
                            <v-btn
                              elevation="2"
                              x-large
                              color="#173053"
                              dark
                              :disabled="!validAdd"
                              @click="addData()"
                            >
                              <v-icon left>mdi-checkbox-marked-circle</v-icon>
                              เพิ่ม
                            </v-btn>
                          </v-row>
                        </v-col>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-form>
            </v-card>
          </v-dialog>
          <!-- end add -->

          <!-- edit -->
          <v-dialog v-model="dialogEdit" persistent max-width="60%">
            <v-card>
              <v-form ref="form_update" v-model="validUpdate" lazy-validation>
                <v-card-text>
                  <v-container>
                    <v-col class="text-right">
                      <v-btn
                        small
                        color="#E0E0E0"
                        @click=";(dialogEdit = false), clearDataUpdate()"
                      >
                        <v-icon color="#173053">mdi-close</v-icon>
                      </v-btn>
                    </v-col>
                    <v-row justify="center">
                      <v-col cols="5" class="text-center">
                        <v-col class="text-center">
                          <v-img
                            class="v-margit_img"
                            :src="require('@/assets/Illustration.svg')"
                          ></v-img>
                        </v-col>
                      </v-col>

                      <v-col cols="6" class="v-margit_text_add">
                        <v-col class="text-center">
                          <v-img
                            class="v_text_edit"
                            :src="require('@/assets/GroupEditTitle.svg')"
                          ></v-img>
                        </v-col>
                        <v-col cols="12">
                          <v-row style="height: 20px">
                            <v-subheader id="subtext">รหัสผู้ใช้</v-subheader>
                          </v-row>
                          <v-row style="height: 60px">
                            <v-text-field
                              placeholder="userCode*"
                              v-model="formUpdate.userCode"
                              :rules="[rules.required]"
                              :counter="30"
                              maxlength="30"
                              required
                              readonly
                            ></v-text-field>
                          </v-row>
                        </v-col>
                        <v-col cols="12">
                          <v-row style="height: 20px">
                            <v-subheader id="subtext">ชื่อผู้ใช้</v-subheader>
                          </v-row>
                          <v-row style="height: 60px">
                            <v-text-field
                              placeholder="userName*"
                              v-model="formUpdate.userName"
                              :rules="[rules.required]"
                              required
                              readonly
                            ></v-text-field>
                          </v-row>
                        </v-col>
                        <v-col cols="12">
                          <v-row style="height: 20px">
                            <v-subheader id="subtext">รหัสผ่าน</v-subheader>
                          </v-row>
                          <v-row style="height: 60px">
                            <v-text-field
                              placeholder="userPassword*"
                              v-model="formUpdate.userPassword"
                              :rules="[rules.required]"
                              :counter="15"
                              maxlength="15"
                              required
                            ></v-text-field>
                          </v-row>
                        </v-col>
                        <v-col cols="12">
                          <v-row style="height: 20px">
                            <v-subheader id="subtext">E-MAIL</v-subheader>
                          </v-row>
                          <v-row style="height: 60px">
                            <v-text-field
                              v-model="formUpdate.userEmail"
                              :rules="[rules.required, rules.email]"
                              placeholder="E-mail"
                            ></v-text-field>
                          </v-row>
                        </v-col>
                        <v-col cols="12">
                          <v-row style="height: 20px">
                            <v-subheader id="subtext"
                              >กลุ่มผู้ใช้งาน</v-subheader
                            >
                          </v-row>
                          <v-row style="height: 65px">
                            <v-autocomplete
                              clearable
                              v-model="formUpdate.userTypeGroup"
                              :items="UserTypeGroup"
                              small-chips
                              :rules="[rules.required]"
                              placeholder="กลุ่มผู้ใช้งาน"
                            ></v-autocomplete>
                          </v-row>
                        </v-col>
                        <v-col cols="12">
                          <v-row style="height: 20px">
                            <v-subheader id="subtext">สาขา</v-subheader>
                          </v-row>
                          <v-row style="height: 60px">
                            <v-select
                              v-model="formUpdate.masBranchID"
                              :items="dataBranch"
                              label="สาขา"
                              dense
                              outlined
                              :rules="[rules.required]"
                            ></v-select>
                          </v-row>
                        </v-col>
                        <v-col cols="12">
                          <v-row style="height: 20px">
                            <v-subheader id="subtext">DISPLAY NAME</v-subheader>
                          </v-row>
                          <v-row style="height: 60px">
                            <v-text-field
                              placeholder="Display Name*"
                              v-model="formUpdate.displayName"
                              :rules="[rules.required]"
                              required
                              dense
                            ></v-text-field>
                          </v-row>
                        </v-col>
                        <!-- <v-col cols="12">
                      <v-row style="height: 20px">
                      <v-subheader id="subtext">ชื่อที่แสดง</v-subheader>
                      </v-row>
                      <v-row style="height: 60px">
                      <v-text-field
                        placeholder="Display Name*"
                        v-model="formUpdate.displayName"
                        :rules="[rules.required]"
                        required
                      ></v-text-field>
                      </v-row>
                    </v-col> -->
                        <!-- <v-col>
                      <v-row style="height: 20px">
                      <v-subheader id="subtext">วันที่หมดอายุ</v-subheader>
                      </v-row>
                      <v-row style="height: 60px">
                    <v-menu
                            v-model="ExpireMenuUpdate"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="formUpdate.EXPIRY_DATE"
                                prepend-icon="mdi-calendar"
                                placeholder="วันที่ หมดอายุ"
                                v-bind="attrs"
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="formUpdate.EXPIRY_DATE"
                              @input="ExpireMenuUpdate = false"
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                dense
                                dark
                                color="red"
                                @click="
                                  (formUpdate.EXPIRY_DATE = ''), (ExpireMenuUpdate = false)
                                "
                              >
                                Clear
                              </v-btn>
                              <v-btn
                                dense
                                color="primary"
                                @click="
                                  (formUpdate.EXPIRY_DATE = new Date()
                                    .toISOString()
                                    .substr(0, 10)),
                                    (ExpireMenuUpdate = false)
                                "
                              >
                                วันที่ปัจจุบัน
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                      </v-row>
                      </v-col> -->
                        <v-col id="margin">
                          <v-row justify="center">
                            <v-btn
                              elevation="2"
                              x-large
                              color="#173053"
                              dark
                              :disabled="!validUpdate"
                              @click="editData()"
                            >
                              <v-icon left>mdi-checkbox-marked-circle</v-icon>
                              บันทึก
                            </v-btn>
                          </v-row>
                        </v-col>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-form>
            </v-card>
          </v-dialog>
          <!-- end edit -->

          <!-- delete -->
          <v-dialog v-model="dialogDelete" persistent max-width="80%">
            <v-card>
              <v-card-title>
                <span class="headline">ลบข้อมูลนี้</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        label="userCode*"
                        v-model="formUpdate.userCode"
                        :rules="[rules.required]"
                        :counter="30"
                        maxlength="30"
                        required
                        readonly
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        label="userName*"
                        v-model="formUpdate.userName"
                        :rules="[rules.required]"
                        :counter="10"
                        maxlength="10"
                        required
                        readonly
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        label="userPassword*"
                        v-model="formUpdate.userPassword"
                        :rules="[rules.required]"
                        :counter="15"
                        maxlength="15"
                        required
                        readonly
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="formUpdate.userEmail"
                        :rules="[rules.required, rules.email]"
                        label="E-mail"
                        readonly
                      ></v-text-field>
                    </v-col>
                    <v-col class="d-flex" cols="12">
                      <!-- <v-autocomplete
                        clearable
                        v-model="formUpdate.userType"
                        :items="userTypeItem"
                        label="ประเภท Account"
                        readonly
                      ></v-autocomplete> -->
                    </v-col>
                    <v-col cols="12">
                      <v-autocomplete
                        clearable
                        v-model="formUpdate.userTypeGroup"
                        :items="UserTypeGroup"
                        attach
                        chips
                        label="กลุ่มผู้ใช้งาน"
                        readonly
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  x-large
                  dark
                  class="btn-color"
                  @click="dialogDelete = false"
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
                <v-btn
                  elevation="2"
                  x-large
                  dark
                  color="red darken-1"
                  @click="deleteData()"
                >
                  <v-icon left>mdi-checkbox-marked-circle</v-icon>
                  ลบ
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end delete -->

          <!-- data table -->
          <v-col cols="12">
            <v-card elevation="7" v-if="dataReady">
              <v-card-title>
                <v-text-field
                  v-model="searchAll2"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-card-text>
                <v-data-table
                  :headers="columns"
                  :items="dataItem"
                  :search="searchAll2"
                  :items-per-page="10"
                >
                  <template v-slot:[`item.CREATE_DATE`]="{ item }">
                    {{ format_dateNotime(item.CREATE_DATE) }}
                  </template>
                  <template v-slot:[`item.LAST_DATE`]="{ item }">
                    {{ format_dateNotime(item.LAST_DATE) }}
                  </template>
                  <template v-slot:[`item.action`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          class="btn-color"
                          fab
                          dark
                          x-small
                          v-if="item.shopId === session.data.shopId"
                          @click.stop=";(dialogEdit = true), getDataById(item)"
                        >
                          <v-icon dark> mdi-tools </v-icon>
                        </v-btn>
                      </template>
                      <span>แก้ไขข้อมูล</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          color="red"
                          dark
                          fab
                          x-small
                          v-if="item.shopId === session.data.shopId"
                          @click.stop="
                            ;(dialogDelete = true), getDataById(item)
                          "
                        >
                          <v-icon> mdi-delete </v-icon>
                        </v-btn>
                      </template>
                      <span>ลบข้อมูล</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
            <div v-if="!dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-col>
          <!-- end data table -->
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../Sidebar.vue' // เมนู
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'
import moment from 'moment' // แปลง date

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    downloadExcel: JsonExcel,
    XLSX,
    readXlsxFile
  },
  // created () {
  //   setInterval(this.getNowGlobal, 1000)
  // },
  data () {
    return {
      PK: '',
      path: '/system_user/', // Path Model
      returnLink: '/system/User',
      dataReady: true,
      dateTime: '', // Generate DateTime
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      ExpireMenu: false,
      ExpireMenuUpdate: false,
      code: 'SYS_USER_', // Generate Code
      // Dialog Config ADD EDIT DELETE IMPORT
      dialogAdd: false,
      dialogEdit: false,
      dialogDelete: false,
      dialogImport: false,
      // END Dialog Config ADD EDIT DELETE
      panel: [0],
      panel1: [1],
      session: this.$session.getAll(),
      // Search All
      searchAll: '',
      searchAll2: '',
      // Search Advanced
      search: {
        displayName: '',
        userName: '',
        userPassword: '',
        userEmail: '',
        // userType: 'U',
        userTypeGroup: '',
        create_date_start: '',
        create_date_end: '',
        last_date_start: '',
        last_date_end: ''
      },
      formAdd: {
        displayName: '',
        userCode: '',
        userName: '',
        userPassword: '',
        userEmail: '',
        // userType: 'U',
        userTypeGroup: '',
        // empCode: '',
        EXPIRY_DATE: '',
        shopId: this.$session.getAll().data.shopId,
        masBranchID: ''
      },
      formUpdate: {
        userId: '',
        userCode: '',
        userName: '',
        userPassword: '',
        userEmail: '',
        // userType: '',
        userTypeGroup: '',
        // empCode: '',
        displayName: '',
        EXPIRY_DATE: '',
        shopId: '',
        masBranchID: ''
      },
      nameRules: [
        v => !!v || 'Name is required',
        v => v.length <= 30 || 'Name must be less than 10 characters'
      ],
      rules: {
        required: value => !!value || 'Required.',
        counter: value => value.length <= 20 || 'Max 20 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      },
      // End Form Config ADD EDIT
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'จัดการ Account',
          disabled: true,
          href: '/System/User'
        }
      ],
      // End Menu Config
      // Data Table Config
      columns: [
        { text: 'userId', value: 'userId' },
        { text: 'ชื่อที่แสดง', value: 'displayName' },
        { text: 'ชื่อผู้ใช้', value: 'userName' },
        { text: 'อีเมล', value: 'userEmail' },
        { text: 'ประเภท', value: 'userTypeGroup' },
        { text: 'วันที่อัพเดท', value: 'LAST_DATE' },
        // { text: 'วันหมดอายุ คงเหลือ (วัน)', value: 'ExpireDateDiff' },
        { text: 'จัดการ', value: 'action', sortable: false, align: 'center' }
      ],
      dataItem: [],
      // End Data Table Config

      // Config Import
      columnsImport: [
        { text: 'userId', value: 'userId' },
        { text: 'userCode', value: 'userCode' },
        { text: 'userName', value: 'userName' },
        { text: 'userPassword', value: 'userPassword' },
        { text: 'userEmail', value: 'userEmail' },
        { text: 'userType', value: 'userType' },
        { text: 'userTypeGroup', value: 'userTypeGroup' },
        { text: 'empCode', value: 'empCode' }
      ],
      dataItemImportChecKHide: true,
      dataItemImport: [],
      // End Config Import
      // Export Config
      exportType: 'xls',
      exportFileName: 'System-User-Account.xls',
      exportWorksheet: 'WorkSheet',
      export_fields: {
        userId: 'userId',
        userCode: 'userCode',
        userName: 'userName',
        userPassword: 'userPassword',
        userEmail: 'userEmail',
        userType: 'userType',
        userTypeGroup: 'userTypeGroup',
        empCode: 'empCode'
      },
      json_meta: [
        [
          {
            key: 'charset',
            value: 'utf-8'
          }
        ]
      ],
      // End Export Config
      UserTypeGroup: [],
      userTypeItem: ['A', 'U'],
      EmployeeName: [],
      validAdd: true,
      validUpdate: true,
      dataBranch: []
    }
  },
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/Core/Login')
    }
  },
  async mounted () {
    // this.getGetToken(this.DNS_IP)
    this.dataReady = false
    // Get Data
    if (this.session.data.userTypeGroup === 'Admin') {
      await this.getDataSystem(this.DNS_IP, this.path)
    } else {
      await this.getDataGlobal(
        this.DNS_IP,
        this.path,
        this.session.data.shopId,
        this.returnLink
      )
    }
    this.getDataBranch()
    await this.reloadData()
  },
  methods: {
    async getDataBranch () {
      // Clear Data ทุกครั้ง
      this.dataBranch = []
      // console.log('getDataCompany')
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/master_branch/' +
            'get?shopId=' +
            this.session.data.shopId
        )
        .then(async response => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.value = d.masBranchID
            s.text = d.masBranchName
            d = s
            this.dataBranch.push(d)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
          this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
        })
    },
    async checkTypeGroup () {
      if (this.session.data.userTypeGroup === 'Admin') {
        await this.getDataSystem(this.DNS_IP, this.path)
      } else {
        await this.getDataGlobal(
          this.DNS_IP,
          this.path,
          this.session.data.shopId,
          this.returnLink
        )
      }
    },
    async getDataSystem (DNS_IP, PATH) {
      // Clear Data ทุกครั้ง
      this.dataItem = []
      // Clear ข้อมูลใน Import
      this.dataItemImport = []
      // Clear ช่องค้นหา
      this.searchAll = ''

      console.log('Test Global')

      await axios
        .get(
          // eslint-disable-next-line quotes
          DNS_IP + PATH + 'get?RECORD_STATUS=N',
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          // var dateObj = new Date(response.data.CREATE_DATE)
          // var momentObj = moment(dateObj)
          // response.data.CREATE_DATE = momentObj.format('YYYY-MM-DD')
          console.log('getData', response.data)
          this.dataReady = true
          this.dataItem = response.data
          this.export_data = response.data
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
          this.$swal('ผิดพลาด', 'ไม่มีข้อมูล', 'error')
          this.dataReady = true
        })
    },
    validate (Action) {
      switch (Action) {
        case 'ADD':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_add.validate()
          })
          break
        case 'UPDATE':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_update.validate()
          })
          break

        default:
          break
      }
    },
    async reloadData (item) {
      // await this.employeeName()
      await this.getDataTypeGroup()
    },
    async getDataById (item) {
      //
      //
      // สำหรับ เรียกข้อมูล ใส่ form Update / Delete
      //
      //
      // Get ID /main.js
      this.dataReady = false
      await this.getDataByIdGlobal(
        this.DNS_IP,
        this.path,
        'userId',
        item.userId
      )
      if (this.formUpdate.EXPIRY_DATE) {
        this.formUpdate.EXPIRY_DATE = moment(
          String(this.formUpdate.EXPIRY_DATE)
        ).format('YYYY-MM-DD')
      } else {
        this.formUpdate.EXPIRY_DATE = ''
      }
    },
    async employeeName () {
      // Clear Data ทุกครั้ง
      this.EmployeeName = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/employee/' + 'get',
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.value = d.empCode
            s.text = d.empFull_NameTH
            d = s
            this.EmployeeName.push(d)
          }
          // console.log('employeeName : ', this.EmployeeName)
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
        })
    },

    async addData () {
      //
      //
      // สำหรับ เพิ่มข้อมูล
      // ต้องระบุ Create / Last User ว่าใครเป็นคนสร้าง
      //
      this.formAdd.CREATE_USER = this.$session.getAll().data.userName
      this.formAdd.LAST_USER = this.$session.getAll().data.userName

      // // // // // // // // // // // // // // // // // // // // // // // // // // // // // //
      //
      // กำหนด Code ของรายการ * อย่าลืมเปลี่ยน field
      //
      this.formAdd.userCode = this.code + this.generateCodeGlobal()
      // YYYY-MM-DD
      this.formAdd.EXPIRY_DATE = this.momenDate_1(this.formAdd.EXPIRY_DATE)
      //
      // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // //

      console.log('form', JSON.stringify(this.formAdd))

      this.dataReady = false
      this.addDataSubmit(this.DNS_IP, this.path, this.formAdd)
    },
    async addDataSubmit (DNS_IP, PATH, DT) {
      this.$swal({
        title: 'ต้องการ เพิ่มข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          await axios
            .get(
              // eslint-disable-next-line quotes
              this.DNS_IP +
                '/system_shop/auth?userName=' +
                this.formAdd.userName
            )
            .then(async response => {
              this.$swal(
                'ผิดพลาด',
                'ขออภัย Admin User นี้มีอยู่ในระบบอยู่แล้ว',
                'error'
              )
              this.formAdd.userName = ''
            }) // eslint-disable-next-line handle-callback-err
            .catch(async error => {
              await axios
                .post(
                  // eslint-disable-next-line quotes
                  DNS_IP + PATH + 'add',
                  DT,
                  {
                    headers: {
                      'Application-Key': this.$session.getAll().ApplicationKey
                    }
                  }
                )
                .then(async response => {
                  // Debug response
                  console.log('addDataGlobal DNS_IP + PATH + "add"', response)

                  this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
                  // Close Dialog
                  this.dialogAdd = false

                  // Load Data
                  await this.checkTypeGroup()
                  // await this.getDataGlobal(this.DNS_IP, this.path, this.session.data.shopId)
                  await this.reloadData()
                  this.clearDataAdd()
                })
                // eslint-disable-next-line handle-callback-err
                .catch(error => {
                  console.log('error function addDataGlobal : ', error)
                  this.dataReady = true
                  this.$router.push(
                    '/system/Errorpage?returnLink=' + this.returnLink
                  )
                })
            })
        })
        .catch(error => {
          console.log('error function addData : ', error)
          this.dataReady = true
        })
    },
    async editData () {
      // this.editDataGlobal(this.DNS_IP, this.path, this.PK, this.formUpdateItem)
      this.dataReady = false

      this.$swal({
        title: 'ต้องการ แก้ไขข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          if (this.formUpdate.EXPIRY_DATE === '') {
            delete this.formUpdate['EXPIRY_DATE']
          }
          this.formUpdate.LAST_USER = this.session.data.userName
          var ID = this.formUpdate.userId
          delete this.formUpdate['userId']
          delete this.formUpdate['LAST_DATE']
          delete this.formUpdate['CREATE_DATE']
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + 'edit/' + ID,
              this.formUpdate
              // {
              //   headers: {
              //     'Application-Key': this.$session.getAll().ApplicationKey
              //   }
              // }
            )
            .then(async response => {
              // Debug response
              console.log('editDataGlobal DNS_IP + PATH + "edit"', response)

              // this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
              // Close Dialog
              this.dialogEdit = false

              // Load Data
              // await this.getDataGlobal(this.DNS_IP, this.path, this.session.data.shopId)
              await this.checkTypeGroup()
              await this.reloadData()
              this.clearDataUpdate()
              this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
            })
            // eslint-disable-next-line handle-callback-err
            .catch(error => {
              this.dataReady = true
              console.log('error function editDataGlobal : ', error)
              this.$router.push(
                '/system/Errorpage?returnLink=' + this.returnLink
              )
            })
        })
        .catch(error => {
          this.dataReady = true
          console.log('error function editDataGlobal : ', error)
        })
    },
    async deleteData () {
      console.log('DELETE PK : ', this.PK)
      //
      //
      // สำหรับ ลบข้อมูล
      // ต้องระบุ  Last User ว่าใครเป็นคนลบล่าสุด
      //
      this.formUpdate.LAST_USER = this.$session.getAll().data.userName
      this.dataReady = false
      this.deleteDataSubmit(
        this.DNS_IP,
        this.path,
        this.PK,
        this.session.data.shopId,
        '',
        this.returnLink
      )
    },
    async deleteDataSubmit (DNS_IP, PATH, ID) {
      this.$swal({
        title: 'ต้องการ ลบข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#fa0202',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          await axios
            .post(
              // eslint-disable-next-line quotes
              DNS_IP + PATH + 'delete/' + ID,
              this.formUpdate,
              {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async response => {
              // Debug response
              console.log('DNS_IP + PATH + "delete/"', response)

              this.$swal('เรียบร้อย', 'ลบข้อมูลเรียบร้อย', 'success')
              // Close Dialog
              this.dialogDelete = false

              // Load Data
              await this.checkTypeGroup()
              // await this.getDataGlobal(this.DNS_IP, this.path, this.session.data.shopId)
              await this.reloadData()
            })
            // eslint-disable-next-line handle-callback-err
            .catch(error => {
              this.dataReady = true
              this.$router.push(
                '/system/Errorpage?returnLink=' + this.returnLink
              )
              console.log('error function deleteDataGlobal : ', error)
            })
        })
        .catch(error => {
          this.dataReady = true
          this.$swal('ผิดพลาด', 'ผิดพลาด -2', 'error')
          console.log('error function deleteDataGlobal : ', error)
        })
    },
    async searchDataAll () {
      //
      //
      // สำหรับ ค้นหาแบบ LIKE Search
      // ต้องระบุ Field ที่จะส่งไปให้ตรงกับ Model
      //
      var search =
        '?displayName=' +
        this.searchAll +
        '&userName=' +
        this.searchAll +
        '&userEmail=' +
        this.searchAll +
        '&userId=' +
        this.searchAll
      this.dataReady = false
      this.searchDataAllGlobal(
        this.DNS_IP,
        this.path,
        search,
        this.session.data.shopId
      )
    },
    async saerchDataAdvanced () {
      var search = ''
      var check = false
      // config วันที่สร้าง วันที่แก้ไข
      // config นำวันที่สิ้นสุดมาต่อ 23:59:59
      // if (
      //   this.search.create_date_start !== '' &&
      //   this.search.create_date_end === ''
      // ) {
      //   this.search.create_date_end =
      //     this.search.create_date_start + ' 23:59:59'
      // } else {
      //   if (this.search.create_date_start !== '') {
      //     this.search.create_date_end =
      //       this.search.create_date_end + ' 23:59:59'
      //   }
      // }

      // if (
      //   this.search.last_date_start !== '' &&
      //   this.search.last_date_end === ''
      // ) {
      //   this.search.last_date_end = this.search.last_date_start + ' 23:59:59'
      // } else {
      //   if (this.search.last_date_end !== '') {
      //     this.search.last_date_end = this.search.last_date_end + ' 23:59:59'
      //   }
      // }
      for (var key in this.search) {
        console.log('Key', key)
        console.log('Value', this.search)

        check = true
        if (this.search[key]) {
          if (search !== '') {
            search += '&'
          }
          search += key + '=' + this.search[key]
        }
      }

      //   if (
      //     this.search.last_date_start === '' &&
      //     this.search.last_date_end !== ''
      //   ) {
      //     check = false
      //     this.$swal('ผิดพลาด', 'กรุณาเลือกวันที่แก้ไข เริ่มต้น', 'error')
      //   }

      //   if (
      //     this.search.create_date_start === '' &&
      //     this.search.create_date_end !== ''
      //   ) {
      //     check = false
      //     this.$swal('ผิดพลาด', 'กรุณาเลือกวันที่สร้าง เริ่มต้น', 'error')
      //   }
      // }
      // console.log('saerchDataAdvanced', search)
      //
      //
      // สำหรับ ค้นหาแบบ กำหนดจาก form serach
      //
      if (check === true) {
        this.dataReady = false

        this.saerchDataAdvancedGlobal(
          this.DNS_IP,
          this.path,
          search,
          this.session.data.shopId
        )
      } else {
        this.dataReady = true
      }
    },
    async getDataTypeGroup () {
      // Clear Data ทุกครั้ง
      this.UserTypeGroup = []
      // console.log('getDataTypeGroup')
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/system_user_type_group/' +
            'get?checkGroup=' +
            this.session.data.userTypeGroup
          // {
          //   headers: {
          //     'Application-Key': this.$session.getAll().ApplicationKey
          //   }
          // }
        )
        .then(async response => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.value = d.userTypeGroupName
            s.text = d.userTypeGroupName
            d = s
            console.log(d)
            this.UserTypeGroup.push(d)
          }
          // console.log('getDataTypeGroup : ', this.UserTypeGroup)
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
        })
    },
    async clearDataAdd () {
      this.formAdd.userCode = ''
      this.formAdd.userName = ''
      this.formAdd.userPassword = ''
      this.formAdd.userEmail = ''
      this.formAdd.userTypeGroup = ''
      this.formAdd.EXPIRY_DATE = ''
      this.formAdd.shopId = this.$session.getAll().data.shopId
      this.formAdd.masBranchID = ''
      this.formAdd.displayName = ''
    },
    async clearDataUpdate () {
      this.formUpdate.userId = ''
      this.formUpdate.userCode = ''
      this.formUpdate.userName = ''
      this.formUpdate.userPassword = ''
      this.formUpdate.userEmail = ''
      this.formUpdate.userTypeGroup = ''
      this.formUpdate.EXPIRY_DATE = ''
      this.formUpdate.shopId = ''
    },
    // * Option Import Excel
    // * ตั้งค่าจาก Data
    importData (event) {
      var input = event.target
      var reader = new FileReader()
      reader.onload = () => {
        var fileData = reader.result
        var wb = XLSX.read(fileData, { type: 'binary' })
        wb.SheetNames.forEach(sheetName => {
          var rowObj = XLSX.utils.sheet_to_json(wb.Sheets[sheetName])
          console.log(rowObj)
          this.dataItemImport = rowObj
        })
        if (this.dataItemImport.length === 0) {
          alert('โปรดใส่ไฟล์ให้ถูกต้อง')
        } else {
          this.dataItemImportChecKHide = false
        }
      }

      reader.readAsBinaryString(input.files[0])
    },
    importDataApprove (action) {
      console.log('Action', action)
      var titleMsg = ''
      var checkError = false
      if (action === 'add') {
        titleMsg = 'ท่านต้องการ นำเข้าข้อมูลจากไฟล์นี้ ใช่หรือไม่'
      } else if (action === 'delete') {
        titleMsg = 'ท่านต้องการ ลบข้อมูลจากไฟล์นี้ ใช่หรือไม่'
      } else {
        titleMsg = 'ท่านต้องการ ปรับปรุงข้อมูลจากไฟล์นี้ ใช่หรือไม่'
      }

      this.$swal({
        title: titleMsg,
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          for (var key in this.dataItemImport) {
            this.PK = this.dataItemImport[key].userId
            if (action === 'add') {
              console.log('add')
              await this.importDataAdd(this.dataItemImport[key])
              checkError = true
            } else {
              await axios
                .get(
                  // eslint-disable-next-line quotes
                  this.DNS_IP +
                    this.path +
                    'get?userId=' +
                    this.dataItemImport[key].userId,
                  {
                    headers: {
                      'Application-Key': this.$session.getAll().ApplicationKey
                    }
                  }
                )
                .then(async response => {
                  if (action === 'update') {
                    await this.importDataUpdate(this.dataItemImport[key])
                    checkError = true
                  }
                  if (action === 'delete') {
                    await this.importDataDelete(this.dataItemImport[key])
                    checkError = true
                  }
                })
                // eslint-disable-next-line handle-callback-err
                .catch(error => {
                  checkError = false

                  console.log('error /system_user/get?userId : ', error)
                })
            }
          }
          console.log(checkError)
          if (checkError === true) {
            await this.checkTypeGroup()
            // await this.getDataGlobal(this.DNS_IP, this.path, this.session.data.shopId)
          } else {
            this.dataItemImport = []
            this.dataItemImportChecKHide = true
            alert('โปรดใส่ไฟล์ให้ถูกต้อง')
          }
        })
        .catch(error => {
          console.log('error function importDataApprove : ', error)
          this.dataReady = true
        })
    },
    async importDataAdd (dt) {
      Object.assign(this.formAdd, dt)
      this.formAdd.CREATE_USER = this.$session.getAll().data.userName
      this.formAdd.LAST_USER = this.$session.getAll().data.userName
      delete this.formAdd['userId']
      delete this.formAdd['LAST_DATE']
      delete this.formAdd['CREATE_DATE']
      delete this.formAdd['RECORD_STATUS']
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + this.path + 'add',
          this.formAdd,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          this.dialogImport = false
          // Debug response
          console.log('/system_user/add/', response)
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          alert('โปรดใส่ไฟล์ให้ถูกต้อง', dt)
          console.log('error function importDataAdd addData : ', error)
          this.dataReady = true
        })
    },
    async importDataUpdate (dt) {
      Object.assign(this.formUpdate, dt)
      delete this.formUpdate['titleID']
      delete this.formUpdate['LAST_DATE']
      delete this.formUpdate['CREATE_DATE']
      delete this.formUpdate['RECORD_STATUS']
      this.formUpdate.LAST_USER = this.$session.getAll().data.userName

      for (var key in this.formUpdateItem) {
        for (var key2 in this.formUpdate) {
          if (key === key2) {
            this.formUpdateItem[key] = this.formUpdate[key2]
          }
        }
      }

      // Debug
      console.log('EDIT PK : ', this.PK)
      console.log('formUpdateItem', JSON.stringify(this.formUpdateItem))

      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + this.path + 'edit/' + dt.titleID,
          this.formUpdateItem,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          this.dialogImport = false
          // Debug response
          console.log('/system_user/edit/', response)
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          alert('โปรดใส่ไฟล์ให้ถูกต้อง', dt)
          console.log('error function importDataUpdate : ', error)
        })
    },
    async importDataDelete (dt) {
      this.formUpdate.LAST_USER = this.$session.getAll().data.userName
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + this.path + 'delete/' + dt.userId,
          this.formUpdate,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          this.dialogImport = false
          // Debug response
          console.log('/system_user/delete/', response)
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          alert('โปรดใส่ไฟล์ให้ถูกต้อง', dt)
          console.log('error function importDataDelete : ', error)
        })
    }
  }
}
</script>
<style scope>
#subtext {
  color: #173053;
  font-size: 20px !important;
  font-weight: bold;
}
#margin {
  margin-top: 30px;
  margin-bottom: 70px;
}
</style>



// WEBPACK FOOTER //
// src/components/System/User.vue